import { IANAZone, type Zone, type ZoneOffsetOptions } from 'luxon';
import type { MomentZone } from 'moment-timezone';

/** Keep Luxon's calendar calculations on the same timezone data as Moment. */
export default class BundledTimezone extends IANAZone {
  constructor(private readonly data: MomentZone) {
    super(data.name);
  }

  // Luxon formats custom zones through UTC rather than asking Intl to apply
  // the browser's potentially older rules a second time.
  get type() {
    return 'bundled';
  }

  get isValid() {
    return true;
  }

  offset(timestamp: number) {
    return -this.data.utcOffset(timestamp);
  }

  offsetName(timestamp: number, options: ZoneOffsetOptions) {
    return super.offset(timestamp) === this.offset(timestamp)
      ? super.offsetName(timestamp, options)
      : this.data.abbr(timestamp);
  }

  equals(other: Zone) {
    return other instanceof BundledTimezone && other.name === this.name;
  }
}
